import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resolveGlobalVessel } from '../utils/globalVessel';

const readStored = () => {
    try { return JSON.parse(localStorage.getItem('Filter') || 'null'); }
    catch { return null; }
};

export default function useGlobalVessel() {
    const [params] = useSearchParams();
    const [stored, setStored] = useState(readStored);
    useEffect(() => {
        const update = () => setStored(readStored());
        const storage = event => { if (event.key === 'Filter' || event.key === null) update(); };
        window.addEventListener('filterUpdated', update);
        window.addEventListener('storage', storage);
        return () => {
            window.removeEventListener('filterUpdated', update);
            window.removeEventListener('storage', storage);
        };
    }, []);
    return resolveGlobalVessel(params, stored);
}
